import { makeStyles } from "tss-react/mui"
import { blueGrey } from "@mui/material/colors"
import { alpha, drawerClasses } from "@mui/material"

export type DrawerSize = "sm" | "md" | "lg"

type StylesParams = { size?: DrawerSize }

export const useStyles = makeStyles<StylesParams>()(
  ({ spacing, shadows }, { size = "md" }) => ({
    drawer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      boxShadow: shadows[6],

      "&:focus": {
        border: "none",
        boxShadow: `${shadows[6]} !important`
      },

      [`&.${drawerClasses.paperAnchorRight}`]: {
        borderTopLeftRadius: "3px",
        borderBottomLeftRadius: "3px",
        top: spacing(9),
        bottom: spacing(3),

        ...(size === "sm" && { width: "562px" }),
        ...(size === "md" && { width: "40%" }),
        ...(size === "lg" && { width: "750px" }),

        height: `calc(100vh - ${spacing(9)} - ${spacing(3)})`
      },

      [`&.${drawerClasses.paperAnchorBottom}`]: {
        borderTopLeftRadius: "3px",
        borderTopRightRadius: "3px",
        width: "100%",

        ...(size === "sm" && { height: "320px" }),
        ...(size === "md" && { height: "480px" }),
        ...(size === "lg" && { height: "560px" })
      }
    },
    backdrop: {
      backgroundColor: "transparent"
    },
    backdropVisible: {
      backgroundColor: alpha(blueGrey[200], 0.6)
    },
    container: {
      height: "100%"
    },
    title: {
      borderBottom: `1px solid ${blueGrey[100]}`,
      flexDirection: "row",
      alignItems: "center"
    },
    actions: {
      width: "100%",
      flexDirection: "row",
      justifyContent: "flex-end",
      alignItems: "center",
      marginTop: "auto"
    }
  })
)
